import { render, staticRenderFns } from "./VxSidebar.vue?vue&type=template&id=6fb5f58e"
import script from "./VxSidebar.vue?vue&type=script&lang=js"
export * from "./VxSidebar.vue?vue&type=script&lang=js"
import style0 from "./VxSidebar.vue?vue&type=style&index=0&id=6fb5f58e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports